<p>
  mapfre-checkbox works!
</p>
